export default __webpack_public_path__ + "static/media/story-bg.b3dea81a.mp4";